import gql from "graphql-tag";

export default gql`
	mutation penaltyPercentage($penalty_percentage: Int!) {
		penaltyPercentage(penaltyPercentage: $penalty_percentage) {
			success
		}
	}
`;
